export function sumRows(arr, columnName) {
  let total = 0;
  try {
    arr.forEach((row) => {
      total += Number(row[columnName]);
    });
  } catch (error) {
    console.error("Error in sumRows function:", error);
    return 0;
  }
  return total || 0;
}
